export default {
    "de": {
        "footer": {
            "impressum": "Impressum",
            "company": "Eine Marke der YBM-Deutschland",
            "privat_policy": "Datenschutzerklärung"
        },
        "header": {
            "storage": {
                "warehouse": "Warehouse",
                "storage": "Storage",
                "rack": "Rack",
                "place": "Storage Place",
                "avis": "Avis",
                "booking": "Buchung"
            },
            "home": "Startseite",
            "management": "Verwaltung",
            "show_users": "Benutzer",
            "create_user": "Benutzer",
            "manage_mandant": "Mandant",
            "manage_abteilung": "Abteilung",
            "manage_pricegroup": "Pricegroup",
            "manage_shop": "Shop",
            "manage_api": "API",
            "manage_storage": "Lager",
            "manage_supplier": "Lieferanten",
            "manage_customer": "Kunden",
            "import": "Hochladen",
            "product": "Produkt",
            "products": "Produkte",
            "order": "Bestellung",
            "orders": "Bestellungen",
            "order_import": "Bestellimport",
            "invoice": "Rechnung",
            "invoices": "Rechnungen",
            "export": "Runterladen",
            "article": "Produkt",
            "article_import": "Produktimport",
            "view": "Übersicht",
            "login": "Anmelden",
            "register": "Registrieren",
            "logout": "Abmelden",
            "profile": "Benutzerprofil",
            "edit": "Bearbeiten",
            "reports": "Berichte",
            "reorder_level": "Meldebestände",
            "report": "Lageranalyse",
            "report_red": "Lageranalyse - Alarm",
            "report_yellow": "Lageranalyse - Warnung",
            "report_green": "Lageranalyse - Ok",
            "live_monitor": "Livemonitoring",
            "non_seller": "Ladenhüter",
            "retoure_view": "Retouren",
            "manage_csv": "Csv Einstellungen",
            "shipping": "Shippingmethoden",
            "provider": "Versandienstleister",
            "mapping": "Versand Übersicht",
            "shop": "Shop Übersicht"
        },
        "mails": {
            "customer": {
                "order": {
                    "invoice": {
                        "subject": "Ihre Rechnung #{invoiceId} für Bestellung #{orderId}"
                    }
                }
            }
        },
        "messages": [],
        "page": {
            "home": {
                "in_total": "Insgesamt",
                "pending": "Ausstehend",
                "processing": "In Bearbeitung",
                "complete": "Abgeschlossen",
                "shipped_today": "Versendungen heute",
                "orders_today": "Bestellungen heute",
                "count_outer_eu": "Bestellungen im Ausland",
                "count_double_orders": "Doppelte Bestellungen",
                "show_more": "Zeige mehr",
                "everything_at_a_glance": "Alles auf einem Blick.",
                "count_express": "Express Sendungen",
                "range_from": "Von",
                "range_to": "Bis"
            },
            "profile": {
                "username": "Benutzername",
                "email": "E-Mail Adresse",
                "password": "Passwort",
                "save": "Speichern",
                "create_user": "Benutzer anlegen"
            },
            "welcome": {
                "title": "Logistik-Portal",
                "home": "Startseite",
                "homepage": "HomePage",
                "news": "Neuigkeiten",
                "contact": "Kontakt",
                "login": "Anmelden",
                "register": "Registrieren"
            },
            "invoice": {
                "title": "Rechnung"
            },
            "management": {
                "user": {
                    "create": {
                        "create_new_user": "Erstelle neuen Benutzer",
                        "name": "Name",
                        "email": "E-Mail-Adresse",
                        "password": "Passwort",
                        "create": "Erstellen"
                    },
                    "view": {
                        "name": "Name",
                        "email": "E-Mail-Adresse",
                        "activate": "Aktivieren",
                        "delete": "Löschen",
                        "login": "Anmelden",
                        "roles": "Rollen",
                        "role": "Rolle",
                        "mandant": "Mandant",
                        "abteilung": "Abteilung"
                    }
                },
                "mandant": {
                    "view": [],
                    "edit": [],
                    "add": {
                        "mandant": "Mandant",
                        "street": "Straße",
                        "company": "Firma",
                        "email": "Email",
                        "phone": "Telefon",
                        "housenumber": "Hausnummer",
                        "country_code": "Ländercode",
                        "plz": "Postleitzahl",
                        "city": "Stadt",
                        "state": "Staat",
                        "first_name": "Vorname",
                        "last_name": "Nachname",
                        "create": "Erstellen",
                        "edit": "Bearbeiten",
                        "delete": "Löschen",
                        "create_mandant": "Mandant erstellen"
                    },
                    "delete": []
                },
                "abteilung": {
                    "view": [],
                    "edit": {
                        "update": "Sind Sie sicher, dass Sie diese Abteilung speichern wollen?"
                    },
                    "add": {
                        "abteilung": "Abteilung",
                        "create_abteilung": "Abteilung erstellen",
                        "customer_number": "Kundennummer",
                        "mandant": "Mandant",
                        "create": "Erstellen",
                        "edit": "Bearbeiten",
                        "save": "Speichern",
                        "delete": "Löschen",
                        "pricegroup": "Preisgruppe",
                        "csv_einstellungen": "CSV Einstellungen bearbeiten",
                        "create_csv": "CSV Einstellen"
                    },
                    "delete": {
                        "message": "Sind Sie sicher, dass Sie diese Abteilung löschen wollen?"
                    }
                },
                "booking": {
                    "booking": "Buchung",
                    "book": "Buchen",
                    "create_manual_booking": "Manuell Buchen",
                    "create_avis_booking": "Avisierung Buchen",
                    "create_rebooking": "Umbuchen",
                    "abteilung": "Abteilung",
                    "stock_old_name": "Alter Lagerplatz",
                    "stock_name": "Lagerplatz",
                    "type": "Typ",
                    "quantity": "Anzahl",
                    "create": "Erstellen",
                    "user": "Ersteller",
                    "created_at": "Erstelldatum",
                    "storage_table": "Lagerbewegungen",
                    "enter_places": "Bitte geben Sie einen Lagerplatz ein",
                    "enter_sku": "Bitte geben Sie eine SKU ein",
                    "enter_quantity": "Bitte tragen Sie die gewünschte Anzahl ein.",
                    "source_place": "Quelllager",
                    "dest_place": "Ziellager"
                },
                "pricegroup": {
                    "add": {
                        "title": "Preisgruppen",
                        "name": "Name",
                        "charge": "Aufpreis",
                        "percent": "Prozent",
                        "delete": "Löschen",
                        "create": "Erstellen",
                        "save": "Speichern",
                        "edit": "Bearbeiten"
                    }
                },
                "edit": {
                    "update": "Sind Sie sicher, dass Sie diese Preisgruppe ändern möchten?"
                },
                "delete": {
                    "message": "Sind Sie sicher, dass Sie diese Preisgruppe löschen möchten?"
                },
                "shop": {
                    "view": {
                        "username": "Benutzername",
                        "email": "E-Mail-Adresse",
                        "shop_config": "Konfiguration",
                        "connections": "Verbindung",
                        "edit": {
                            "add": "Hinzufügen",
                            "user": "Benutzer",
                            "create_bearer": "Token erstellen",
                            "usadder": "Hinzufügen",
                            "abteilung": "Abteilung",
                            "shop": "Shop",
                            "edit": "Bearbeiten",
                            "config": "Konfiguration",
                            "save": "Speichern",
                            "url": "URL",
                            "version": "Version",
                            "clientid": "ClientId",
                            "clientsecret": "ClientSecret",
                            "password": "Passwort",
                            "easybill_bearer": "Easybill Bearer",
                            "easybill_id": "Easybill Kunden Id"
                        }
                    },
                    "add": [],
                    "delete": []
                },
                "import": {
                    "product": {
                        "import": "Hochladen",
                        "import_article": "Produkte Hochladen",
                        "article": "Produkt",
                        "products": "Produkte",
                        "product": "Produkt",
                        "import_system": "Verkaufskanal",
                        "csv_file_to_import": "CSV-Datei zum Importieren",
                        "abteilung": "Abteilung",
                        "file_contains_header_row": "Datei enthält eine Kopfzeile?",
                        "no_file_selected": "Keine Datei ausgewählt",
                        "select_file": "Datei auswählen"
                    },
                    "order": {
                        "import": "Hochladen",
                        "import_order": "Bestellungen Hochladen",
                        "orders": "Bestellungen",
                        "order": "Bestellung",
                        "csv_file_to_import": "CSV-Datei zum Importieren",
                        "abteilung": "Abteilung",
                        "file_contains_header_row": "Datei enthält eine Kopfzeile",
                        "no_file_selected": "Keine Datei ausgewählt",
                        "select_file": "Datei auswählen"
                    },
                    "customer": {
                        "import_customer": "Kunden Hochladen"
                    },
                    "supplier": {
                        "import_supplier": "Lieferant Hochladen"
                    },
                    "invoice": {
                        "import": "Hochladen",
                        "import_invoice": "Rechnungen Hochladen",
                        "invoices": "Rechnungen",
                        "invoice": "Rechnung",
                        "csv_file_to_import": "CSV-Datei zum Importieren",
                        "abteilung": "Abteilung",
                        "file_contains_header_row": "Datei enthält eine Kopfzeile",
                        "no_file_selected": "Keine Datei ausgewählt",
                        "select_file": "Datei auswählen"
                    },
                    "storage": {
                        "import": "Hochladen",
                        "import_storage": "Lager Hochladen",
                        "orders": "Bestellungen",
                        "import_system": "Importkanal",
                        "storage": "Lager",
                        "csv_file_to_import": "CSV-Datei zum Importieren",
                        "abteilung": "Abteilung",
                        "file_contains_header_row": "Datei enthält eine Kopfzeile",
                        "no_file_selected": "Keine Datei ausgewählt",
                        "select_file": "Datei auswählen"
                    },
                    "import": "Hochladen",
                    "csv_file_to_import": "CSV-Datei zum Importieren",
                    "abteilung": "Abteilung",
                    "file_contains_header_row": "Datei enthält eine Kopfzeile",
                    "no_file_selected": "Keine Datei ausgewählt",
                    "select_file": "Datei auswählen",
                    "import_system": "Verkaufskanal"
                },
                "export": {
                    "product": {
                        "article": "aaaaaaaaaaaa",
                        "products": "aaaaaaaaaaaa",
                        "product": "aaaaaaaaaaaa",
                        "csv_file_to_import": "aaaaaaaaaaaa",
                        "abteilung": "aaaaaaaaaaaa",
                        "file_contains_header_row": "aaaaaaaaaaaa",
                        "no_file_selected": "aaaaaaaaaaaa",
                        "select_file": "aaaaaaaaaaaa"
                    },
                    "order": {
                        "get_export": "Exportieren",
                        "export_order": "Bestellung Exportieren",
                        "article": "aaaaaaaaaaaa",
                        "products": "aaaaaaaaaaaa",
                        "product": "aaaaaaaaaaaa",
                        "csv_file_to_import": "aaaaaaaaaaaa",
                        "abteilung": "aaaaaaaaaaaa",
                        "file_contains_header_row": "aaaaaaaaaaaa",
                        "no_file_selected": "aaaaaaaaaaaa",
                        "select_file": "aaaaaaaaaaaa"
                    },
                    "invoice": {
                        "export_invoice": "Rechnung Exportieren",
                        "abteilung": "Abteilung",
                        "abteilung_all": "Alle Abteilungen",
                        "already_exported": "Exportieren bereits exportierte Rechnungen",
                        "export": "Rechnung erstellen"
                    }
                },
                "warehouse": {
                    "warehouses": "Lagerhäuser",
                    "warehouse": "Lagerhaus",
                    "name": "Name",
                    "street": "Straße",
                    "city": "Stadt",
                    "new": "Neu",
                    "edit": "Bearbeiten",
                    "create": "Erstellen",
                    "export": "Export",
                    "storage": {
                        "choose_rack": "Regal",
                        "warehouse": "Lagerhaus",
                        "storage": "Lager",
                        "storage_rack": "Lagerregal",
                        "quantity": "Anzahl",
                        "update": "Bearbeiten",
                        "create": "Erstellen",
                        "delete": "Löschen",
                        "storage_place": "Lagerplatz",
                        "place_table": "Lagerplatz Tabelle",
                        "place_name": "Name",
                        "place_width": "Breite",
                        "place_height": "höhe",
                        "place_length": "Länge",
                        "place_x": "X",
                        "place_y": "Y",
                        "place_z": "Z",
                        "takeOver": "Änderungen übernehmen",
                        "create_storage_rack": "Lagerregal erstellen?",
                        "update_storage_rack": "Lagerregal bearbeiten?",
                        "delete_storage_rack": "Lagerregal löschen?",
                        "create_storage": "Lager erstellen?",
                        "update_storage": "Lager bearbeiten?",
                        "delete_storage": "Lager löschen?",
                        "choose": "Lager auswählen"
                    }
                },
                "avis": {
                    "avis": "Avisierung",
                    "avis_number": "Avisierungs-Nummer",
                    "delivery_note_number": "Lieferscheinnummer",
                    "delivery_date": "Ankunft",
                    "supplier": "Lieferant",
                    "status": "Status",
                    "edit": "Bearbeiten",
                    "filter": "Filter",
                    "book": "Buchen",
                    "quantity": "Anzahl",
                    "add_avis": "Avisierung erstellen",
                    "choose_supplier": "Bitte wählen Sie einen Lieferanten aus",
                    "choose_status": "Bitte wählen Sie einen Status aus",
                    "add_avis_question": "Möchstest du wirklich diesen Avisierungsauftrag erstellen?",
                    "avis_error": "Fehler beim bearbeiten der Avisierungs-Daten:",
                    "enter_sku": "Bitte geben Sie eine sku ein."
                },
                "customer": {
                    "create": "Anlegen",
                    "number": "Kundennummer",
                    "first_name": "Vorname",
                    "last_name": "Nachname",
                    "company": "Firma",
                    "email": "EMail",
                    "phone": "Telefon",
                    "street": "Straße",
                    "street_nr": "Straße Nr.",
                    "country_code": "Land",
                    "plz": "PLZ",
                    "city": "Stadt",
                    "state": "Staat",
                    "filter": "Filter",
                    "customer": "Kunden",
                    "search": "Suchen",
                    "import": "Import"
                },
                "supplier": {
                    "supplier": "Lieferant",
                    "filter": "Filter",
                    "customer_number": "Kundennummer",
                    "name": "Name",
                    "number": "Nummer",
                    "is_dropshipping": "Dropshipping",
                    "first_name": "Vorname",
                    "last_name": "Nachname",
                    "company": "Firma",
                    "email": "Email",
                    "phone": "Telefonnummer",
                    "street": "Straße",
                    "street_nr": "Hausnummer",
                    "country_code": "Ländercode",
                    "plz": "Postleitzahl",
                    "city": "Stadt",
                    "state": "Bundesland",
                    "search": "Suchen",
                    "create": "Erstellen",
                    "import": "Importieren",
                    "supplier_was_created": "Lieferant erfolgreich erstellt",
                    "add_supplier_q": "Möchten Sie diesen Lieferanten anlegen?"
                }
            },
            "product": {
                "view": {
                    "product": "Produkt",
                    "products": "Produkte",
                    "interface": "Schnittstelle",
                    "rebook": "Umbuchen",
                    "name": "Name",
                    "sku": "SKU",
                    "stock": "Bestand",
                    "search": "Suchen",
                    "filter": "Filter",
                    "manufacturer": "Hersteller",
                    "commodity_code": "Zolltarifnummer",
                    "weight": "Gewicht",
                    "create": "Erstellen",
                    "add_product": "Produkt erstellen",
                    "product_was_created": "Product wurde angelegt",
                    "add_product_q": "Produkt anlegen?",
                    "edit_product_q": "Produkt bearbeiten?",
                    "width": "Breite",
                    "height": "Höhe",
                    "length": "Länge",
                    "status": "Status",
                    "price_gros": "Preis Brutto",
                    "price_net": "Preis Netto",
                    "comanufacturer": "Herstellungsland",
                    "update": "Aktualisieren",
                    "storage": "Lager",
                    "reorder_level": "Mindestbestand",
                    "variation_header": "Variationen",
                    "bundle_header": "Bundleprodukte",
                    "supplier_header": "Lieferanten",
                    "description_header": "Beschreibung",
                    "connectors_header": "Shopsystem",
                    "media_assets_header": "Medien",
                    "supplier": "Lieferant",
                    "delivery_time": "Lieferzeit",
                    "supplier_standard": "Standardlieferant wählen",
                    "quantity": "Anzahl",
                    "qty_locked": "Anzahl reserviert",
                    "qty_shipped": "Anzahl versendet",
                    "data": "Daten",
                    "relations": "Beziehungen",
                    "rack": "Regal",
                    "storage_place": "Lagerplatz",
                    "category": "Kategorie",
                    "attributes": "Attribute",
                    "attribute": "Attribut",
                    "value": "Wert",
                    "print": "Drucken",
                    "print_erp_report": "ERP-Drucken",
                    "export_csv": "CSV Exportieren",
                    "add": "Hinzufügen",
                    "all_channel": "Alle Kanäle",
                    "extern_number": "Externe Nummer",
                    "stock_reserved": "Reserviert",
                    "stock_net": "Nettobestand",
                    "packaging_type": "Verpackungstyp",
                    "wrapping_factor": "Faktor",
                    "stock_change": "Lager bearbeiten",
                    "delete_variant_relation_title": "Variantrelation löschen?",
                    "delete_variant_relation": "Wollen Sie diese Variantrelation wirklich löschen?",
                    "delete_bundle_relation_title": "Bundlerelation löschen?",
                    "delete_bundle_relation": "Wollen Sie diese Bundlerelation wirklich löschen?",
                    "nonseller": "Ladenhüter",
                    "inventory_management": "Bestandsführung",
                    "product_was_rebooked": "Produkt wurde Umgebucht",
                    "abteilung": "Abteilung",
                    "media_assets": {
                        "assets_header": "Medien",
                        "images_header": "Bilder",
                        "name": "Name",
                        "image": "Bild",
                        "image_width": "Bildbreite",
                        "image_height": "Bildhöhe",
                        "add_image": "Bild hinzufügen"
                    }
                },
                "reorder_level": {
                    "id": "ID",
                    "sku": "SKU",
                    "name": "Name",
                    "report": "Lageranalyse",
                    "storage_place": "Lagerplatz",
                    "supplier": "Lieferant",
                    "reorder_level": "Meldebestand",
                    "erp_report": "ERP-REPORT",
                    "current_stock": "Aktueller Bestand",
                    "in_avis": "In Avisierung",
                    "all_pages": "Alle Produkte",
                    "last_sold": "Verkauft letzte 6 Monate",
                    "sold_per_day": "Verkauft am Tag",
                    "sold_per_year": "Verkäufe pro Jahr",
                    "stock_range": "Lagerreichweite in Tagen",
                    "delivery_time": "Nachlieferzeit",
                    "stock_status": "Lagerstatus",
                    "status_green": "Status grün",
                    "status_yellow": "Status gelb",
                    "status_red": "Status rot",
                    "product_type_bundle": "Bundleprodukte",
                    "product_type_configurable": "Konfigurierbare Produkte",
                    "all_tags": "Alle Kategorien",
                    "restock": "Nachbestellen",
                    "alert": "Alarm",
                    "warning": "Warnung"
                },
                "edit": {
                    "modal": {
                        "reserved_stock": "Reservierter Bestand",
                        "id": "ID",
                        "order_number": "Bestellnummer",
                        "reserved": "Reserviert",
                        "error_title": "Fehler!",
                        "quantity_is_no_number": "Das Feld \"Anzahl\" ist keine Zahl.",
                        "insert_quantity": "Bitte wählen Sie eine Anzahl aus.",
                        "edit_bundle_title": "Bundleprodukt",
                        "edit_configurable_title": "Konfigurierbares Produkt",
                        "save": "Speichern",
                        "close": "Verwerfen",
                        "product": "Produkt",
                        "quantity": "Anzahl",
                        "add_supplier_title": "Lieferant hinzufügen",
                        "add_supplier_message": "Bitte wählen Sie einen Lieferanten den Sie hinzufügen möchten.",
                        "choose_supplier": "Bitte wählen Sie einen Lieferanten aus.",
                        "ok": "Ok"
                    }
                },
                "add": [],
                "delete": [],
                "nonseller": "Ladenhüter"
            },
            "order": {
                "view": {
                    "order": "Bestellung",
                    "orders": "Bestellungen",
                    "order_number": "Bestellnummer",
                    "country": "Land",
                    "address": "Adresse",
                    "status": "Status",
                    "edit": "Bearbeiten",
                    "export": "Runterladen",
                    "print": "PDF Drucken",
                    "search": "Suche",
                    "import_channel": "Shopsystem",
                    "order_date": "Bestelldatum",
                    "invoice_received": "Rechnung erhalten",
                    "yes": "Ja",
                    "no": "Nein",
                    "name": "Name",
                    "create_order": "Erstelle Bestellung",
                    "by_country": "Nach Land",
                    "inner_eu": "Innerhalb der EU",
                    "outer_eu": "Außerhalb der EU",
                    "is_express": "Nur Express",
                    "details": {
                        "back": "Zurück",
                        "title": "Bestelldetails",
                        "order_date": "Bestelldatum",
                        "delivery_info": "Versandinformation",
                        "shipper": "Versand",
                        "shipping_method": "Versandmethode",
                        "abteilung": "Abteilung",
                        "invoice_received": "Rechnung erhalten",
                        "yes": "Ja",
                        "no": "Nein",
                        "allow_reprint": "Erlaube erneuten Rechnungsdruck",
                        "ship_to": "Versand an",
                        "details": "Details",
                        "name": "Name",
                        "description": "Beschreibung",
                        "quantity": "Anzahl",
                        "price": "Preis",
                        "sum": "Summe",
                        "street": "Straße",
                        "housenumber": "Hausnummer",
                        "country_code": "Ländercode",
                        "plz": "PLZ",
                        "company": "Firma",
                        "city": "Stadt",
                        "state": "Staat",
                        "additional": "Zusätzliche Addresszeile",
                        "first_name": "Vorname",
                        "last_name": "Nachname",
                        "status": "Status",
                        "phone": "Telefon",
                        "email": "E-Mail",
                        "shipment_id": "Versender ID",
                        "shipping_date": "Datum",
                        "package": "Paket",
                        "package_id": "Paket ID",
                        "tracking_number": "Trackingnummer",
                        "items": "Produkte",
                        "change_status_close": "Bestellung stornieren",
                        "change_status_complete": "Bestellung abschließen",
                        "change_status": "Status ändern",
                        "change_status_return": "Retoure hinzufügen",
                        "save": "Speichern",
                        "shipping_details": "Versanddetails",
                        "delete_shipments": "Versand löschen",
                        "prio": "Bestellung prioisieren"
                    },
                    "retoure": {
                        "create": "Retoure anlegen",
                        "headline": "Retoure",
                        "reasons": "Grund",
                        "notiz": "Zusätzliche Informationen",
                        "customer": "Kunde",
                        "condition": "Zustand",
                        "type": "Art der Retoure",
                        "retoure_exists": "Es wurde bereits eine Retour angelegt und von der verfügbaren Menge abgezogen"
                    }
                },
                "edit": [],
                "add": [],
                "delete": [],
                "create": {
                    "data": "Daten",
                    "shipto": "Versandadresse",
                    "billto": "Rechnungsadresse",
                    "items": "Artikel",
                    "abteilung": "Abteilung",
                    "status": "Status",
                    "shipping_methods": "Versandarten",
                    "ordernumber": "Bestellnummer",
                    "externordernumber": "Externe Bestellnummer",
                    "sku": "SKU",
                    "name": "Name",
                    "quantity": "Anzahl",
                    "price": "Preis",
                    "firstname": "Vorname",
                    "lastname": "Nachname",
                    "company": "Firma",
                    "street": "Straße",
                    "housenumber": "Hausnummer",
                    "additional_lines": "Zusätzliche Adresszeile(n)",
                    "plz": "PLZ",
                    "city": "Stadt",
                    "state": "Staat",
                    "countrycode": "Ländercode",
                    "email": "E-Mail",
                    "phone": "Telefonnummer",
                    "create": "Erstellen",
                    "product": "Artikel",
                    "same_as_shipto": "Nutze Versandadresse",
                    "choose_abteilung": "Bitte wählen Sie eine Abteilung aus.",
                    "choose_status": "Bitte wählen Sie einen Bestellstatus aus.",
                    "choose_shipping_method": "Bitte wählen Sie eine Versandmethode aus.",
                    "cod": "Nachnahme"
                },
                "scheduledShipmentDate": "geplantes Versanddatum"
            },
            "inventory": {
                "view": [
                    "inventory"
                ],
                "edit": []
            },
            "delivery": {
                "view_headline": "Lieferscheine",
                "view": {
                    "number": "Bestellnummer",
                    "company": "Firma",
                    "name": "Name",
                    "first_rack": "Startregal",
                    "delivery_print": "Drucken",
                    "view": "Lieferscheine",
                    "printall": "Alle Drucken",
                    "default_shelf": "Standard Regal"
                },
                "pdf": {
                    "pos": "Pos",
                    "qty": "Menge",
                    "id": "Artikel-ID",
                    "articledescription": "Artikelbeschreibung",
                    "delivery_note": "Lieferschein",
                    "order_number": "Auftrags-Nr.",
                    "paymentmethod": "Zahlungsart",
                    "shippingmethod": "Versandart",
                    "deliveryaddress": "Lieferanschrift"
                }
            },
            "login": {
                "login": "Anmelden",
                "email_address": "E-Mail-Adresse",
                "password": "Passwort",
                "remember_me": "Anmeldung merken",
                "forgot_your_password": "Passwort vergessen?",
                "password_reset": {
                    "reset_password": "Passwort zurücksetzen",
                    "email_address": "E-Mail-Adresse",
                    "send_password_reset_link": "Sende Zurücksetzungsemail",
                    "confirm_password": "Bestätige Passwort"
                }
            },
            "register": {
                "register": "Registrieren",
                "name": "Name",
                "email_address": "E-Mail-Adresse",
                "password": "Passwort",
                "confirm_password": "Passwort bestätigen"
            },
            "modal": {
                "yes": "Ja",
                "no": "Nein"
            },
            "dashboard": {
                "articles": "ORDERS",
                "done": "FULFILLED ITEMS",
                "remaining": "REMAINING",
                "im_process": "IN PROGRESS",
                "station_a_head": "SUPERMAGNETS",
                "station_b_head": "FOILS",
                "station_c_head": "ACCESSORIES",
                "Ad_Items": "MIXED ORDER ID",
                "station_a": "MIXED A",
                "station_b": "MIXED B",
                "station_c": "MIXED C",
                "left": "ORDERS",
                "right": "ORDERS",
                "open": "OPEN ORDERS",
                "shipped": "SHIPPED ORDERS",
                "missing": "ORDERED ITEMS",
                "double_orders": "DOUBLE"
            },
            "csv": {
                "titel": "Csv Einstellungen",
                "abteilung_id": "wählen sie eine Abteilung aus",
                "host": "Geben sie einen Host ein",
                "user": "Geben sie ihren User ein",
                "password": "Geben sie ihr Password ein",
                "root": "Geben sie den root Pfad ein",
                "port": "Geben sie den freigeschalteten Port ein",
                "delimiter": "Geben sie ein Trennzeichen ein",
                "active": "Csv Aktivieren",
                "encoding": "Zeichensatz Auswählen",
                "ssl": "ssl Verschlüsselung Aktivieren",
                "sslVerifyPeer": "ssl Verifizierter Peer eingeben",
                "sslVerifyHost": "sll Host eingeben",
                "has_header": "Die Csv hat ein Header",
                "header": "Geben sie den Header ein",
                "save": "Speichern",
                "has_config": "Daten Konfigurieren",
                "order_number": "Order Nummer",
                "shipping_method": "Shipping Methoden",
                "shipping_method_id": "Shipping Methoden id",
                "shipTo_name1": "Empfänger Vorname",
                "shipTo_name2": "Empfänger Nachname",
                "shipTo_name3": "Empfänger Prefix",
                "shipTo_street": "Empfänger Straße",
                "shipTo_housenumber": "die Empfänger HausNr.",
                "shipTo_country": "Empfänger Land",
                "shipTo_plz": "Empfänger Postleitzahl",
                "shipTo_city": "Empfänger Stadt",
                "shipTo_email": "Empfänger E-mail",
                "shipTo_additional": "Empfänger Adresszusatzzeile",
                "position": "Zeile für die Artikel",
                "has_position": "Artikel Konfigurieren",
                "position_delimiter": "Trennzeichen für die Artikel",
                "position_id": "ID des Artikels",
                "position_sku": "SKU des Artikels",
                "position_name": "Artikelnamen des Artikels",
                "position_country": "Herstellerland des Artikels",
                "position_commodity_code": "Zolltarifnummer des Artikels",
                "position_weight": "Gewicht des Artikels",
                "position_amount": "Preis des Artikels",
                "position_count": "Anzahl des Artikels",
                "position_last": "Letzde Zeile des Artikels",
                "weahlen": "Wähle..."
            },
            "shipping": {
                "overview": " Versandmethoden Übersicht",
                "create": " Versandmethode Erstellen",
                "edit": " Versandmethode Bearbeiten",
                "shipper": "Versanddienstleister",
                "is_express": "Express",
                "name": "Name der Sendungsart",
                "express_true": "Expresssendung",
                "express_false": "keine Expresssendung",
                "createview": "Erstelle eine Shippingmethode",
                "overview_name": "Name",
                "shop": "Shop",
                "int_name": "Logistik App Versand Namen",
                "ShipperEdit": "Versanddienstleiter Bearbeiten",
                "save": "Versanddienstleiter Speichern",
                "ShippingMethodEdit": "Berarbeitung der Versand Methoden",
                "shippingEdit": "Bearbeitung der Shipping Methoden",
                "saveMethod": "Versandmethode Speichern",
                "ShippingMethodMapping": "Mapping speichern",
                "VersandMethode": " Versandmethode"
            },
            "provider": {
                "overview": " Versanddienstleister Übersicht",
                "create": " Versanddienstleister Erstellen",
                "edit": " Versanddienstleister Bearbeiten",
                "shipper": "Versanddienstleister",
                "name": "Name des Versanddienstleister",
                "createview": "Erstelle einen Versanddienstleister",
                "overview_name": "Name"
            },
            "mapping": {
                "overview": "Versandmethoden Mapping",
                "name_int": "Versandbezeichnung Intern",
                "name_ext": "Versandbezeichnung Extern"
            },
            "shop": {
                "name": "Shop",
                "abteilung": "Abteilung",
                "connector": "Modul",
                "edit": "Bearbeiten",
                "overview": "Shop Übersicht",
                "mapping": "Mappings",
                "actions": "Aktionen"
            },
            "picklist": {
                "pdf": {
                    "title": "Picklist",
                    "billTo": "Rechnungsadresse",
                    "shipTo": "Versandadresse",
                    "shipping": "Versandart",
                    "payment": "Zahlungsart",
                    "items": {
                        "sku": "SKU",
                        "storage": "Lager",
                        "storage_rack": "Regal",
                        "storage_place": "Lagerplatz",
                        "product_name": "Bezeichnung",
                        "qty": "Menge",
                        "ean": "EAN"
                    }
                },
                "edit": {
                    "open": 'Öffnen',
                    "load_order": 'Pickliste laden',
                    "edit_order": 'Pickliste bearbeiten',
                    "next_order": 'Pickliste abschließen',
                    "order_number": 'Bestellnummer',
                    "back": 'Zurück',
                    "ship_to_address": 'Lieferanschrift',
                    "ship_from_address": 'Absenderaddresse',
                    "sku": 'Sku',
                    "picked": 'Gepickt',
                    "housenumber": 'Hausnummer',
                    "quantity": 'Anzahl',
                    "vp": 'Verpackung',
                    "content": 'Inhalt',
                    "unit_kg": 'kg',
                    "company": 'Firma',
                    "firstname": 'Vorname',
                    "lastname": 'Nachname',
                    "name3": 'Name3',
                    "street": 'Straße',
                    "country": 'Land',
                    "plz": 'PLZ',
                    "city": 'Ort',
                    "phone": 'Telefonnummer',
                    "add": 'Hinzufügen',
                    "cancel": 'Abbrechen',
                    "ok": 'OK',
                    "ordered_at": 'Auftragsdatum',
                    "loading_at": 'Beladedatum',
                    "loading_at_to": 'Beladen von',
                    "loading_at_from": 'Beladen bis',
                    "please_wait": 'Bitte warten Sie einen Moment.',
                    "scan": "Artikelbarcode"
                }
            }
        },
        "string": [],
        "validation": {
            "double": "{attribute} ist keine Fließkommazahl.",
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "Das Datum {attribute} muss sich nach dem datum {date} befinden.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "{attribute} und {other} müssen unterschiedlich sein.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "Das ausgewählte Feld {attribute} existiert nicht.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "Das Feld {attribute} ist ein Pflichtfeld.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "{attribute} muss {size} Zeichen lang sein.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "Der {attribute} ist bereits vorhanden.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },

    },
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "footer": {
            "impressum": "Impressum",
            "company": "© 2017 ::: Eine Marke von YBM-Deutschland",
            "privat_policy": "Privat Policy"
        },
        "header": {
            "storage": {
                "warehouse": "Lagerhaus",
                "storage": "Lager",
                "rack": "Gestell",
                "place": "Lagerplatz",
                "avis": "Avisierung",
                "booking": "Booking"
            },
            "home": "Home",
            "management": "Management",
            "show_users": "Users",
            "create_user": "User",
            "manage_mandant": "Client",
            "manage_abteilung": "Department",
            "manage_pricegroup": "Price group",
            "manage_shop": "Shop",
            "manage_api": "API",
            "manage_storage": "Storage",
            "manage_supplier": "Supplier",
            "manage_customer": "Customer",
            "import": "Import",
            "product": "Product",
            "products": "Products",
            "order": "Order",
            "orders": "Orders",
            "order_import": "Order import",
            "invoice": "Invoice",
            "invoices": "Invoices",
            "export": "Export",
            "article": "Article",
            "article_import": "Product import",
            "view": "View",
            "login": "Login",
            "register": "Register",
            "logout": "Logout",
            "profile": "Userprofile",
            "edit": "Edit",
            "reports": "Reports",
            "reorder_level": "Reorder level",
            "report": "Inventory analysis",
            "report_red": "Inventory analysis - Alert",
            "report_yellow": "Inventory analysis - Warning",
            "report_green": "Inventory analysis - Ok",
            "live_monitor": "Live monitoring",
            "non_seller": "Non-Seller",
            "retoure_view": "Retoure-View",
            "manage_csv": "Csv Config",
            "shipping": "Shipping Config",
            "provider": "Provider Config"
        },
        "messages": [],
        "page": {
            "home": {
                "in_total": "In Total",
                "pending": "Pending",
                "processing": "Processing",
                "complete": "Complete",
                "shipped_today": "Shipments today",
                "orders_today": "Orders today",
                "count_outer_eu": "Order outer eu",
                "count_double_orders": "Double orders",
                "show_more": "Show more",
                "count_express": "Express Orders",
                "everything_at_a_glance": "Everything at a glance."
            },
            "profile": {
                "username": "Username",
                "email": "E-Mail Address",
                "password": "Password",
                "save": "Save"
            },
            "welcome": {
                "title": "Logistik-Portal",
                "home": "Home",
                "homepage": "HomePage",
                "news": "News",
                "contact": "Contact",
                "login": "Login",
                "register": "Register"
            },
            "invoice": {
                "title": "Invoice"
            },
            "management": {
                "user": {
                    "create": {
                        "create_new_user": "Create New User",
                        "name": "Name",
                        "email": "E-Mail-Addresse",
                        "password": "Password",
                        "create": "Create"
                    },
                    "view": {
                        "name": "Name",
                        "email": "E-Mail-Addresse",
                        "activate": "Activate",
                        "delete": "Delete",
                        "login": "Login",
                        "roles": "Roles",
                        "role": "Role",
                        "mandant": "Mandant",
                        "abteilung": "Department"
                    }
                },
                "mandant": {
                    "view": [],
                    "edit": [],
                    "add": {
                        "mandant": "Mandant",
                        "street": "street",
                        "company": "Company",
                        "email": "Email",
                        "phone": "Phone",
                        "housenumber": "Housenumber",
                        "country_code": "Country Code",
                        "plz": "PLZ",
                        "city": "City",
                        "state": "State",
                        "first_name": "First Name",
                        "last_name": "Last Name",
                        "create": "Create",
                        "edit": "Edit",
                        "delete": "Delete",
                        "create_mandant": "Create Mandant"
                    },
                    "delete": []
                },
                "abteilung": {
                    "view": [],
                    "edit": {
                        "update": "Are you sure you want to save this Department?"
                    },
                    "add": {
                        "name": "Name",
                        "abteilung": "Department",
                        "create_abteilung": "Create Department",
                        "customer_number": "Customer number",
                        "mandant": "Mandant",
                        "create": "Create",
                        "edit": "Edit",
                        "save": "Save",
                        "delete": "Delete",
                        "pricegroup": "Pricegroup"
                    },
                    "delete": {
                        "message": "Are you sure you want to delete this Department?"
                    }
                },
                "booking": {
                    "booking": "Booking",
                    "book": "Book",
                    "create_manual_booking": "Manual booking",
                    "create_avis_booking": "Avis booking",
                    "create_rebooking": "Rebook",
                    "create": "Create",
                    "abteilung": "Department",
                    "stock_old_name": "Old storage",
                    "stock_name": "Storage",
                    "type": "Type",
                    "quantity": "Count",
                    "user": "Creator",
                    "created_at": "Creation date",
                    "storage_table": "Stock changes",
                    "enter_places": "Enter the storage place",
                    "enter_sku": "Enter the article sku",
                    "enter_quantity": "Enter the quantity",
                    "source_place": "Source storage place",
                    "dest_place": "Destination storage place"
                },
                "pricegroup": {
                    "add": {
                        "title": "Price groups",
                        "name": "Name",
                        "charge": "Charge",
                        "percent": "Percent",
                        "delete": "Delete",
                        "create": "Create",
                        "save": "Save",
                        "edit": "Edit"
                    },
                    "edit": {
                        "update": "Are you sure you want to update the price group?"
                    },
                    "delete": {
                        "message": "Are you sure you want to delete the price group?"
                    }
                },
                "shop": {
                    "view": {
                        "username": "Username",
                        "email": "E-Mail-Addresse",
                        "shop_config": "Shop Config",
                        "connections": "Connections",
                        "edit": {
                            "user": "User",
                            "create_bearer": "Generate Token",
                            "add": "Add",
                            "abteilung": "Department",
                            "shop": "Shop",
                            "edit": "Edit",
                            "config": "Config",
                            "save": "Save",
                            "url": "URL",
                            "version": "Version",
                            "clientid": "ClientId",
                            "clientsecret": "ClientSecret",
                            "password": "Password",
                            "easybill_bearer": "Easybill Bearer",
                            "easybill_id": "Easybill Customer Id"
                        }
                    },
                    "add": [],
                    "delete": []
                },
                "import": {
                    "product": {
                        "import": "Import",
                        "import_article": "Import: Products",
                        "article": "Product",
                        "products": "Products",
                        "product": "Product",
                        "import_system": "Channel",
                        "csv_file_to_import": "CSV File To Import",
                        "abteilung": "Department",
                        "file_contains_header_row": "File Contains Header Row?",
                        "no_file_selected": "No File Selected",
                        "select_file": "Select File"
                    },
                    "order": {
                        "import": "Import",
                        "import_order": "Import: Orders",
                        "orders": "Orders",
                        "order": "Order",
                        "csv_file_to_import": "CSV File To Import",
                        "abteilung": "Department",
                        "file_contains_header_row": "File Contains Header Row",
                        "no_file_selected": "No File Selected",
                        "select_file": "Select File"
                    },
                    "supplier": {
                        "import_supplier": "Import: Supplier"
                    },
                    "invoice": {
                        "import": "Import",
                        "import_order": "Import: Invoices",
                        "orders": "Invoices",
                        "invoices": "Invoice",
                        "csv_file_to_import": "CSV File To Import",
                        "abteilung": "Department",
                        "file_contains_header_row": "File Contains Header Row",
                        "no_file_selected": "No File Selected",
                        "select_file": "Select File"
                    },
                    "storage": {
                        "import": "Import",
                        "import_storage": "Import: Storage",
                        "storages": "Storage",
                        "storage": "Storage",
                        "import_system": "Import channel",
                        "csv_file_to_import": "CSV File To Import",
                        "abteilung": "Department",
                        "file_contains_header_row": "File Contains Header Row",
                        "no_file_selected": "No File Selected",
                        "select_file": "Select File"
                    },
                    "import": "Import",
                    "csv_file_to_import": "CSV File To Import",
                    "abteilung": "Department",
                    "file_contains_header_row": "File Contains Header Row",
                    "no_file_selected": "No File Selected",
                    "select_file": "Select File",
                    "import_system": "Verkaufskanal"
                },
                "export": {
                    "product": {
                        "import": "aaaaaaaaaaaa",
                        "article": "aaaaaaaaaaaa",
                        "products": "aaaaaaaaaaaa",
                        "product": "aaaaaaaaaaaa",
                        "csv_file_to_import": "aaaaaaaaaaaa",
                        "abteilung": "aaaaaaaaaaaa",
                        "file_contains_header_row": "aaaaaaaaaaaa",
                        "no_file_selected": "aaaaaaaaaaaa",
                        "select_file": "aaaaaaaaaaaa"
                    },
                    "order": {
                        "get_export": "Export",
                        "export_order": "Export Order",
                        "import": "aaaaaaaaaaaa",
                        "article": "aaaaaaaaaaaa",
                        "products": "aaaaaaaaaaaa",
                        "product": "aaaaaaaaaaaa",
                        "csv_file_to_import": "aaaaaaaaaaaa",
                        "abteilung": "aaaaaaaaaaaa",
                        "file_contains_header_row": "aaaaaaaaaaaa",
                        "no_file_selected": "aaaaaaaaaaaa",
                        "select_file": "aaaaaaaaaaaa"
                    },
                    "invoice": {
                        "export_invoice": "Export invoice",
                        "abteilung": "Department",
                        "abteilung_all": "All departures",
                        "already_exported": "Export already exported invoices",
                        "export": "Create invoice"
                    }
                },
                "warehouse": {
                    "warehouses": "Warehouses",
                    "warehouse": "Warehouse",
                    "name": "Name",
                    "street": "Street",
                    "city": "City",
                    "new": "New",
                    "edit": "Edit",
                    "create": "Create",
                    "export": "Export",
                    "storage": {
                        "choose_rack": "Choose Rack",
                        "warehouse": "Warehouse",
                        "storage": "Storage",
                        "storage_place": "Storage Place",
                        "storage_rack": "Storage Rack",
                        "quantity": "Quantity",
                        "update": "Update",
                        "create": "Create",
                        "delete": "Delete",
                        "place_table": "Storage Place Table",
                        "place_name": "Name",
                        "place_width": "Width",
                        "place_height": "Height",
                        "place_length": "Length",
                        "place_x": "X",
                        "place_y": "Y",
                        "place_z": "Z",
                        "takeOver": "Make changes",
                        "create_storage_rack": "Create storage rack?",
                        "update_storage_rack": "Update storage rack?",
                        "delete_storage_rack": "Delete storage rack?",
                        "create_storage": "Create storage?",
                        "update_storage": "Update storage?",
                        "delete_storage": "Delete storage?",
                        "choose": "Choose Storage"
                    }
                },
                "avis": {
                    "avis": "Announcement",
                    "avis_number": "Announce-Number",
                    "book": "Booking",
                    "delivery_note_number": "Delivery note number",
                    "delivery_date": "Delivery-Date",
                    "supplier": "Supplier",
                    "status": "Status",
                    "edit": "Edit",
                    "filter": "Filter",
                    "quantity": "Quantity",
                    "add_avis": "Create announcement",
                    "choose_supplier": "Choose a supplier, please",
                    "choose_status": "Choose a status, please",
                    "add_avis_question": "Do you really want to create this announcement?",
                    "avis_error": "Error on processing the announcement-data",
                    "enter_sku": "Enter the sku or product name, please."
                },
                "customer": {
                    "create": "Create",
                    "number": "Number",
                    "first_name": "First Name",
                    "last_name": "Last Name",
                    "company": "Company",
                    "email": "EMail",
                    "phone": "Phone",
                    "street": "Street",
                    "street_nr": "Street Nr.",
                    "country_code": "Country",
                    "plz": "Zipcode",
                    "city": "City",
                    "state": "State",
                    "filter": "Filter",
                    "customer": "Customers",
                    "search": "Search",
                    "import": "Import"
                },
                "supplier": {
                    "supplier": "Supplier",
                    "filter": "Filter",
                    "name": "Name",
                    "customer_number": "Customer number",
                    "number": "Number",
                    "is_dropshipping": "Dropshipping",
                    "first_name": "Firstname",
                    "last_name": "Lastname",
                    "company": "Company",
                    "email": "Email",
                    "phone": "Phone number",
                    "street": "Street",
                    "street_nr": "House number",
                    "country_code": "Country code",
                    "plz": "Postcode",
                    "city": "City",
                    "state": "State",
                    "search": "Search",
                    "create": "Create",
                    "import": "Import",
                    "supplier_was_created": "Supplier successfully created.",
                    "add_supplier_q": "Do you want to create this new supplier?"
                }
            },
            "product": {
                "view": {
                    "product": "Product",
                    "products": "Products",
                    "interface": "Interface",
                    "rebook": "Rebook",
                    "name": "Name",
                    "sku": "SKU",
                    "stock": "Stock",
                    "search": "Search",
                    "filter": "Filter",
                    "manufacturer": "Manufacturer",
                    "commodity_code": "Commodity Code",
                    "weight": "Weight",
                    "create": "Create",
                    "add_product": "Add Product",
                    "product_was_created": "Product created",
                    "add_product_q": "Add product?",
                    "edit_product_q": "Edit product?",
                    "width": "Width",
                    "height": "Height",
                    "length": "Length",
                    "status": "Status",
                    "price_gros": "Price gross",
                    "price_net": "Price net",
                    "comanufacturer": "Country of manufacturer",
                    "update": "Update product",
                    "storage": "Storage",
                    "reorder_level": "Reorder level",
                    "variation_header": "Variations",
                    "bundle_header": "Bundle products",
                    "supplier_header": "Suppliers",
                    "description_header": "Description",
                    "connectors_header": "Shopsystem",
                    "media_assets_header": "Media assets",
                    "supplier": "Supplier",
                    "delivery_time": "Delivery time",
                    "supplier_standard": "Standard supplier",
                    "quantity": "Quantity",
                    "qty_locked": "Quantity locked",
                    "qty_shipped": "Quantity shipped",
                    "data": "Data",
                    "relations": "Relations",
                    "rack": "Rack",
                    "storage_place": "Storage place",
                    "category": "Category",
                    "attributes": "Attributes",
                    "attribute": "Attribute",
                    "value": "Value",
                    "print": "Print",
                    "print_erp_report": "Print ERP-Report",
                    "add": "Add",
                    "export_csv": "Export CSV",
                    "extern_number": "Extern number",
                    "all_channel": "All channel",
                    "stock_reserved": "Reserved",
                    "stock_net": "Stock net",
                    "packaging_type": "Packaging factor",
                    "wrapping_factor": "Factor",
                    "stock_change": "Stock change",
                    "delete_variant_relation_title": "Delete variant relation?",
                    "delete_variant_relation": "Do you really want to delete this variant relation?",
                    "delete_bundle_relation_title": "Delete bundle relation?",
                    "delete_bundle_relation": "Do you really want to delete this bundle relation?",
                    "nonseller": "Non-Seller",
                    "inventory_management": "Inventory management",
                    "product_was_rebooked": "Product was rebooked",
                    "abteilung": "Department",
                    "media_assets": {
                        "assets_header": "Media",
                        "images_header": "Images",
                        "name": "Name",
                        "image": "Image",
                        "image_width": "Image width",
                        "image_height": "Image height",
                        "add_image": "Add Image"
                    }
                },
                "reorder_level": {
                    "id": "ID",
                    "sku": "SKU",
                    "name": "Name",
                    "report": "Inventory analysis",
                    "supplier": "Supplier",
                    "storage_place": "Storage",
                    "reorder_level": "Reorder level",
                    "erp_report": "ERP-REPORT",
                    "current_stock": "Stock",
                    "in_avis": "In Avis",
                    "all_pages": "All Products",
                    "last_sold": "Sold the last 6 Month",
                    "sold_per_day": "Sold per day",
                    "sold_per_year": "Sales per year",
                    "stock_range": "Stock range in days",
                    "delivery_time": "Delivery time",
                    "stock_status": "Stock status",
                    "status_green": "Status green",
                    "status_yellow": "Status yellow",
                    "status_red": "Status red",
                    "product_type_bundle": "Bundle products",
                    "product_type_configurable": "Configurable products",
                    "all_tags": "All categories",
                    "restock": "Restock",
                    "alert": "Alert",
                    "warning": "Warning"
                },
                "edit": {
                    "modal": {
                        "error_title": "Failure!",
                        "quantity_is_no_number": "The field quantity is not a number.",
                        "insert_quantity": "Please insert a quantity.",
                        "edit_bundle_title": "Bundle product",
                        "edit_configurable_title": "Configurable produkt",
                        "save": "Save",
                        "close": "Discard",
                        "product": "Product",
                        "quantity": "Quantity",
                        "add_supplier_title": "Add Supplier",
                        "add_supplier_message": "Please choose a supplier.",
                        "choose_supplier": "Please choose a supplier."
                    }
                },
                "add": [],
                "delete": [],
                "nonseller": "Non-Seller"
            },
            "order": {
                "view": {
                    "order": "Order",
                    "orders": "Orders",
                    "order_number": "Ordernumber",
                    "country": "Country",
                    "address": "Addresse",
                    "status": "Status",
                    "edit": "Edit",
                    "export": "Export",
                    "print": "Print PDF",
                    "search": "Search",
                    "import_channel": "Shop",
                    "order_date": "Order date",
                    "invoice_received": "Invoice received",
                    "yes": "Yes",
                    "no": "No",
                    "name": "Name",
                    "create_order": "Create Order",
                    "by_country": "By Country",
                    "inner_eu": "Inner EU",
                    "outer_eu": "Outer EU",
                    "is_express": "Only Express",
                    "details": {
                        "back": "Back",
                        "title": "Order Details",
                        "order_date": "Oder Date",
                        "delivery_info": "Delivery Info",
                        "shipper": "Shipper",
                        "shipping_method": "Shipping Method",
                        "abteilung": "Department",
                        "yes": "Yes",
                        "no": "No",
                        "allow_reprint": "Allow invoice reprint",
                        "invoice_received": "Invoice received",
                        "ship_to": "Ship To",
                        "details": "Details",
                        "name": "Name",
                        "description": "Description",
                        "quantity": "Quantity",
                        "price": "Price",
                        "sum": "Total",
                        "street": "Street",
                        "housenumber": "Housenumber",
                        "country_code": "Country Code",
                        "company": "Company",
                        "plz": "PLZ",
                        "city": "City",
                        "state": "State",
                        "first_name": "Fist Name",
                        "last_name": "Last Name",
                        "status": "Status",
                        "phone": "Phone",
                        "email": "E-Mail",
                        "additional": "Additional address line",
                        "shipment_id": "Shipment ID",
                        "shipping_date": "Date",
                        "package": "Package",
                        "package_id": "Package ID",
                        "tracking_number": "Trackingnumber",
                        "items": "Products",
                        "change_status_close": "Cancel order",
                        "change_status_complete": "Complete order",
                        "change_status": "Change Status",
                        "change_status_return": "Add retour",
                        "save": "Save",
                        "shipping_details": "Shipping details",
                        "delete_shipments": "Delete Shipments",
                        "prio": "Prioritize order",
                        "scheduled_shipment_date": "Scheduled Shipment Date",
                    },
                    "retoure": {
                        "create": "Add retoure",
                        "headline": "Retoure",
                        "reasons": "Reasons",
                        "notiz": "Additional Informations",
                        "customer": "Customer",
                        "condition": "Condition",
                        "type": "Type of return",
                        "retoure_exists": "A retoure has already been created and deducted from the available quantity"
                    }
                },
                "edit": [],
                "add": [],
                "delete": [],
                "create": {
                    "data": "Data",
                    "shipto": "Shipping address",
                    "billto": "Billing address",
                    "items": "Items",
                    "abteilung": "Department",
                    "status": "Status",
                    "shipping_methods": "Shipping methods",
                    "ordernumber": "Ordnernumber",
                    "externordernumber": "extern ordernumber",
                    "sku": "SKU",
                    "name": "Name",
                    "quantity": "Quantity",
                    "price": "Price",
                    "firstname": "First name",
                    "lastname": "Last name",
                    "company": "Company",
                    "street": "Street",
                    "housenumber": "Housenumber",
                    "additional_lines": "Additional lines",
                    "plz": "PLZ",
                    "city": "City",
                    "state": "State",
                    "countrycode": "Countrycode",
                    "phone": "Phone",
                    "create": "create",
                    "product": "Product",
                    "same_as_shipto": "Use shipping address",
                    "choose_abteilung": "Please choose a department.",
                    "choose_status": "Please choose an order status.",
                    "choose_shipping_method": "Please choose a shipping method.",
                    "cod": "Cash On Delivery"
                }
            },
            "inventory": {
                "view": [],
                "edit": []
            },
            "delivery": {
                "view_headline": "Delivery Notes",
                "view": {
                    "number": "Ordernumber",
                    "company": "Company",
                    "name": "Name",
                    "first_rack": "First Shelf",
                    "delivery_print": "Print",
                    "view": "Delivery Notes",
                    "printall": "Print all",
                    "default_shelf": "Default Shelf"
                },
                "pdf": {
                    "pos": "Pos",
                    "qty": "Quantity",
                    "id": "Article-ID",
                    "articledescription": "Article description",
                    "delivery_note": "Delivery Note",
                    "order_number": "Order-Nr.",
                    "paymentmethod": "Payment method",
                    "shippingmethod": "Shipping method",
                    "deliveryaddress": "Delivery address"
                }
            },
            "login": {
                "login": "Login",
                "email_address": "E-Mail-Addresse",
                "password": "Password",
                "remember_me": "Remember Me",
                "forgot_your_password": "Forgot Your Password?",
                "password_reset": {
                    "reset_password": "Reset Password",
                    "email_address": "E-Mail-Addresse",
                    "send_password_reset_link": "Send Passwort Reset Link",
                    "confirm_password": "Confirm Password"
                }
            },
            "register": {
                "register": "Register",
                "name": "Name",
                "email_address": "E-Mail-Addresse",
                "password": "Password",
                "confirm_password": "Confirm Password"
            },
            "modal": {
                "yes": "Ja",
                "no": "Nein"
            },
            "dashboard": {
                "articles": "ORDERS",
                "done": "FULFILLED ITEMS",
                "remaining": "REMAINING",
                "im_process": "IN PROGRESS",
                "station_a_head": "SUPERMAGNETS",
                "station_b_head": "FOILS",
                "station_c_head": "ACCESSORIES",
                "Ad_Items": "ADD ITEMS",
                "station_a": "MIXED A",
                "station_b": "MIXED B",
                "station_c": "MIXED C",
                "left": "ORDERS",
                "right": "ORDERS",
                "open": "OPEN",
                "shipped": "SHIPPED",
                "missing": "MISSING ITEMS",
                "double_orders": "DOUBLE"
            },
            "csv": {
                "title": "Csv Settings",
                "department_id": "select a department",
                "host": "enter a host",
                "user": "Enter your user",
                "password": "Enter your password",
                "root": "Enter the root path",
                "port": "Enter the activated port",
                "delimiter": "Enter a separator",
                "active": "activate CSV",
                "encoding": "select character set",
                "ssl": "Enable ssl encryption",
                "sslVerifyPeer": "Enter ssl verified peer",
                "sslVerifyHost": "Enter sll host",
                "has_header": "The CSV has a header",
                "header": "enter the header",
                "save": "save",
                "has_config": "configure data",
                "order_number": "Enter the line for the order number",
                "shipping_method": "Enter the line for the shipping methods",
                "shipping_method_id": "Enter the line for the shipping methods id",
                "shipTo_name1": "Enter the line for the recipient first name",
                "shipTo_name2": "Enter the line for the recipient last name",
                "shipTo_name3": "Enter the line for the recipient prefix",
                "shipTo_street": "Enter the line for the recipient street",
                "shipTo_housenumber": "Enter the line for the recipient house number",
                "shipTo_country": "Enter the line for the recipient country",
                "shipTo_plz": "Enter the line for the recipient's zip code",
                "shipTo_city": "Enter the line for the recipient city",
                "shipTo_email": "Enter the line for the recipient email",
                "shipTo_additional": "Enter the line for the recipient's additional address line",
                "item_sku": "Enter the line for the item Sku",
                "item_weight": "Enter the line for the item weight",
                "item_price": "Enter the line for the item price",
                "item_qty": "Enter the line for the item number",
                "item_commodity": "Enter the line for the customs number",
                "item_country": "Enter the line for the manufacturer country",
                "item_name": "Enter the line for the item name",
                "position": "Enter the line for the articles",
                "has_position": "Configure Article",
                "position_delimiter": "Enter a separator for the items",
                "position_id": "Enter a line with the article ID",
                "position_sku": "Enter a line in which the SKU of the article is",
                "position_name": "Enter a line that contains the article name of the article",
                "position_country": "Enter a line in which the country of manufacture of the item is located",
                "position_commodity_code": "Enter a line in which the customs tariff number of the item is",
                "position_weight": "Enter a line in which the weight of the article is",
                "position_amount": "Enter a line in which the price of the item is",
                "position_count": "Enter a line in which the number of the article is",
                "position_last": "Enter the last line of the article",
                "weahlen": "Choose..."
            },
            "shipping": {
                "overview": "shipping method overview",
                "create": "create shipping method",
                "edit": "edit shipping method",
                "shipper": "shipping service provider",
                "is_express": "express",
                "name": "name of the shipment type",
                "express_true": "express delivery",
                "express_false": "standard delivery",
                "createview": "create a shipping method",
                "overview_name": "name",
                "shop": "Shop"
            },
            "provider": {
                "overview": "shipping provider overview",
                "create": "create shipping provider",
                "edit": "edit shipping provider",
                "shipper": "shipping service provider",
                "name": "name of the shipping provider",
                "createview": "create a shipping provider",
                "overview_name": "name"
            },
            "mapping": {
                "overview": "Internal  und external Shipping Names",
                "name_int": "Logistik App Shipping names",
                "name_ext": "Shops Shipping names"
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "string": {
            "Processing": "Processing",
            "Complete": "Complete",
            "In Total": "In Total",
            "Orders Today": "Orders Today",
            "Article": "Article",
            "Product": "Product",
            "Products": "Products",
            "Order": "Order",
            "Orders": "Orders",
            "Managment": "Managment",
            "Home": "Home",
            "View": "View",
            "Edit": "Edit",
            "Show User": "Show User",
            "Create User": "Create User",
            "Manage Mandant": "Manage Mandant",
            "Manage Abteilungen": "Manage Abteilung",
            "Manage Shop": "Manage Shop",
            "Import": "Import",
            "Logout": "Logout",
            "Login": "Login",
            "Register": "Register",
            "Homepage": "Homepage",
            "News": "News",
            "Contact": "Contact",
            "E-Mail Address": "E-Mail Address",
            "Password": "Password",
            "Confirm Password": "Confirm Password",
            "Remember Me": "Remember Me",
            "Forgot Your Password?": "Forgot Your Password?",
            "Reset Password": "Reset Password",
            "Send Password Reset Link": "Send Password Reset Link",
            "Show more": "Show more",
            "Everything at a glance": "Everything at a glance",
            "Roles": "Roles",
            "Delete": "Delete",
            "Activate": "Activate",
            "Create": "Create",
            "Create Mandant": "Create Mandant",
            "Street": "Street",
            "Housenumber": "Housenumber",
            "CountryCode": "CountryCode",
            "PLZ": "PLZ",
            "City": "City",
            "State": "State",
            "First Name": "First Name",
            "Last Name": "Last Name",
            "Username": "Username",
            "Connections": "Connections",
            "Connection": "Connection",
            "Shop config": "Shop config",
            "User": "User",
            "Users": "Users",
            "Config": "Config",
            "Save": "Save",
            "CSV file to import": "CSV file to import",
            "File contains header row": "File contains header row",
            "Select File": "Select File",
            "No File selected": "No File selected",
            "Filter": "Filter",
            "Search": "Search",
            "Manufacturer": "Manufacturer",
            "CommodityCode": "CommodityCode",
            "Country": "Country",
            "Order Number": "Order Number",
            "Delivery Info": "Delivery Info",
            "Delivery Infos": "Delivery Infos",
            "Order Date": "Order Date",
            "Shipper": "Shipper",
            "Shipping Method": "Shipping Method",
            "Description": "Description",
            "Quantity": "Quantity",
            "Ship To": "Ship To",
            "Change Status": "Change Status",
            "Phone": "Phone"
        },
        "validation": {
            "double": "{attribute} is no double.",
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
